import { Component, input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  imports: [],
  template: `
    @if (isVisible()) {
      <div class="spinner-backdrop" role="status" aria-live="polite" aria-label="Loading">
        <div class="spinner"></div>
      </div>
    }
  `,
  styles: `
    .spinner-backdrop {
      position: fixed;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--color-overlay);
      z-index: 1000;
    }

    .spinner {
      width: 10em;
      height: 10em;
      border-radius: 50%;
      border: 1.1rem solid var(--color-loader-track);
      border-left-color: var(--color-loader-accent);
      animation: spinner-rotate 1.1s linear infinite;
    }

    @keyframes spinner-rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
})
export class Spinner {
  isVisible = input<boolean>(false);
}
